// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-screener-container {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  box-sizing: border-box;
  container-type: inline-size;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 328px;
}

/* Only while the popup is open: it is capped at 100% of this container, so
   a short one would squash it. Unconditionally this left a blank gap. */
.fund-screener-container-criteria-open {
  min-height: 900px;
}

.fund-screener {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.fund-screener-table-pagination-wrapper {
  /* Sized to content, not stretched to fill the page — a forced min-height
     left a big blank gap below the table whenever a filter narrowed the
     results down to just a few rows. */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  margin: 0 32px;
}

.fund-screener-table-pagination-wrapper.fund-screener-table-pagination-wrapper-mobile {
  margin: 0 16px;
}

.fund-screener-backdrop {
  /* Covers the screener container only — matches the popup, which is
     centred on that container rather than on the viewport. */
  position: absolute;
  inset: 0;
  z-index: 999;
}

.fund-screener-table-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fund-screener-pagination-container {
  flex-shrink: 0;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundScreenerWidget/FundScreenerWidget.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;wEACwE;AACxE;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;;uCAEqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;6DAC2D;EAC3D,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".fund-screener-container {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  box-sizing: border-box;\n  container-type: inline-size;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 328px;\n}\n\n/* Only while the popup is open: it is capped at 100% of this container, so\n   a short one would squash it. Unconditionally this left a blank gap. */\n.fund-screener-container-criteria-open {\n  min-height: 900px;\n}\n\n.fund-screener {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.fund-screener-table-pagination-wrapper {\n  /* Sized to content, not stretched to fill the page — a forced min-height\n     left a big blank gap below the table whenever a filter narrowed the\n     results down to just a few rows. */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  margin: 0 32px;\n}\n\n.fund-screener-table-pagination-wrapper.fund-screener-table-pagination-wrapper-mobile {\n  margin: 0 16px;\n}\n\n.fund-screener-backdrop {\n  /* Covers the screener container only — matches the popup, which is\n     centred on that container rather than on the viewport. */\n  position: absolute;\n  inset: 0;\n  z-index: 999;\n}\n\n.fund-screener-table-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fund-screener-pagination-container {\n  flex-shrink: 0;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
